var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"re-shop-product-editor"},[_c(_vm.getProductItemComponent(),_vm._b({tag:"component"},'component',_vm.getProductItemAttrs(),false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }